module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-sgbrideonthehunt-md-0eac5d9a4c06a20a4f3072f9f0280cf9.png";